// extracted by mini-css-extract-plugin
export default {"root":"Landing_root__Z+PWh","navWrapper":"Landing_navWrapper__5BhON"};